import { ReduxUtils } from '../../../dependencies';
import { types } from '../../actions';

const actionTypes = {
    REQUEST: types.UPDATE_REPORT_REQUEST,
    SUCCESS: types.UPDATE_REPORT_SUCCESS,
    FAILURE: types.UPDATE_REPORT_FAILURE,
    CANCEL: types.UPDATE_REPORT_CANCEL,
    RESET: types.UPDATE_REPORT_RESET,
};

const basicReducer = ReduxUtils.basicApiReducer({
    actionTypes,
});

export default ReduxUtils.containerReducer({
    childReducer: basicReducer,
    actionTypes: Object.values(actionTypes),
    selectors: {
        itemId: action => action.meta.id,
    },
});
